import { useState } from 'react';
import { ExpandedState } from '@tanstack/react-table';
import { ALL_PRODUCTS, COLLAPSE_ALL, EXPAND_ALL } from 'src/components/PriceSchemeFilters/PriceSchemeFilters';

export const usePriceSchemeFilters = () => {
  const [missingDefaultPriceFilter, setMissingDefaultPriceFilter] = useState<string>(ALL_PRODUCTS);
  const [expandCollapseFilter, setExpandCollapseFilter] = useState<string>(COLLAPSE_ALL);
  const [expanded, setExpanded] = useState<ExpandedState>({});

  const onExpandCollapseFilterChange = (id: string) => {
    setExpandCollapseFilter(id);
    setExpanded(id === EXPAND_ALL ? true : {});
  };

  return {
    missingDefaultPriceFilter,
    setMissingDefaultPriceFilter,
    missingDefaultPrice: missingDefaultPriceFilter !== ALL_PRODUCTS,
    expandCollapseFilter,
    onExpandCollapseFilterChange,
    expanded,
    setExpanded,
  };
};
